import React, { useState, useRef, useEffect } from 'react';
import { AiOutlineClose, AiOutlineMenu } from 'react-icons/ai';
import {
  FaInstagram,
  FaWhatsapp,
  FaUser,
  FaCalendarAlt,
  FaCreditCard,
  FaSignOutAlt,
  FaChevronDown,
  FaSlidersH,
  FaExchangeAlt,
} from 'react-icons/fa';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  doc,
  getDoc,
  collection,
  query,
  where,
  getDocs,
  Timestamp,
} from 'firebase/firestore';
import { db } from '../firebase/config';
import useConfigSitio from "../hooks/useConfigSitio";


const FEATURES = {
  userAccordionOpenByDefault: true,
  showSessionsBadge: true,
};




const getInitials = (str = '') => {
  const parts = (str || '').trim().split(/\s+/);
  if (parts.length === 1) return parts[0]?.[0]?.toUpperCase() || 'U';
  return (parts[0]?.[0] + parts[1]?.[0]).toUpperCase();
};

const Navbar = () => {
  const { config } = useConfigSitio();
  const [nav, setNav] = useState(false);
  const [menuVisible, setMenuVisible] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileUserMenuOpen, setMobileUserMenuOpen] = useState(false);
  const [nombrePerfil, setNombrePerfil] = useState('');
  const [upcomingCount, setUpcomingCount] = useState(0);
  const [editorOpen, setEditorOpen] = useState(false);
  const [desktopMenuOpen, setDesktopMenuOpen] = useState(false);


  const dropdownRef = useRef(null);
  const desktopMenuRef = useRef(null);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const isWorkerRole = user?.rol === 'worker';

  const inAdminView =
    user?.rol === 'admin' && location.pathname.startsWith('/admin');
  const inWorkerView =
    user?.rol === 'worker' && location.pathname.startsWith('/trabajador');

  const handleNav = () => {
    if (nav) {
      setNav(false);
      setTimeout(() => setMenuVisible(false), 400);
    } else {
      setMenuVisible(true);
      setTimeout(() => setNav(true), 10);
    }
  };

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const toggleMobileUserMenu = () => setMobileUserMenuOpen(!mobileUserMenuOpen);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const goAdmin = () => navigate('/admin/agenda');
  const goUsuario = () => navigate('/');
  const goTrabajador = () => navigate('/trabajador/agenda');

  const isActive = (path) => location.pathname === path;
  const nombreUsuario = nombrePerfil || user?.email?.split('@')[0] || 'Usuario';

  useEffect(() => {
    const obtenerNombre = async () => {
      if (!user?.email) return;
      try {
        const docRef = doc(db, 'usuarios', user.email);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) setNombrePerfil(docSnap.data().nombres || '');
      } catch (error) {
        console.error('Error al obtener el nombre del perfil:', error);
      }
    };
    obtenerNombre();
  }, [user]);

  useEffect(() => {
    const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdownOpen(false);
    }

    if (
      desktopMenuRef.current &&
      !desktopMenuRef.current.contains(event.target)
    ) {
      setDesktopMenuOpen(false);
    }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    setMobileUserMenuOpen(FEATURES.userAccordionOpenByDefault ? !!user : false);
  }, [user]);

  useEffect(() => {
    const fetchUpcoming = async () => {
      if (!FEATURES.showSessionsBadge || !user?.uid || user?.rol !== 'usuario') {
        setUpcomingCount(0);
        return;
      }
      try {
        const q = query(
          collection(db, 'sesiones'),
          where('uid', '==', user.uid)
        );
        const snap = await getDocs(q);
        const nowMs = Timestamp.now().toMillis();
        const count = snap.docs.filter((d) => {
          const data = d.data() || {};
          const ts = data.fecha instanceof Timestamp ? data.fecha : null;
          const notCanceled =
            (data.estado || '').toLowerCase() !== 'cancelada';
          return ts && ts.toMillis() >= nowMs && notCanceled;
        }).length;
        setUpcomingCount(count);
      } catch (e) {
        console.warn('No se pudo calcular sesiones próximas.', e);
        setUpcomingCount(0);
      }
    };
    fetchUpcoming();
  }, [user]);

return (
  <>
    <div
      key={inAdminView ? 'admin' : 'public'}
      className={`w-full fixed top-0 z-50 ${inAdminView ? 'bg-[#0b2052] text-white' : 'bg-[#0b2052] text-white'}`}
    >
      <div className="shadow-sm">
        <div className="flex justify-between items-center h-16 md:h-24 max-w-screen-xl mx-auto px-6 md:px-8">
          <div className="flex items-center gap-6">
            <Link
              to={inAdminView ? '/admin/agenda' : '/'}
              className="block w-28 md:w-[180px]"
              aria-label="Inicio"
            >
              <img
                src={
                  inAdminView
                    ? '/fotos/Logo_blanco_EKINE.png'
                    : '/fotos/Logo_blanco_EKINE.png'
                }
                alt="Logo EKINE"
                className="w-full h-auto"
              />
            </Link>

                {!inAdminView && !isWorkerRole && (
                  <div
                    className="relative hidden md:flex items-center"
                    ref={desktopMenuRef}
                  >
                    <button
                      onClick={() => setDesktopMenuOpen(v => !v)}
                      className="flex items-center gap-2 text-white font-semibold text-lg hover:opacity-80"
                    >
                      <AiOutlineMenu size={22} />
                      <span>Menú</span>
                    </button>

                    {desktopMenuOpen && (
                      <div className="absolute left-0 top-full mt-3 w-64 bg-[#0b2052] border border-white rounded-xl shadow-lg z-50">
                        <ul className="py-2 text-sm font-medium text-white">
                          <li><Link to="/" onClick={() => setDesktopMenuOpen(false)} className="block px-5 py-3 hover:bg-blue-900">Home</Link></li>
                          <li><Link to="/servicios" onClick={() => setDesktopMenuOpen(false)} className="block px-5 py-3 hover:bg-blue-900">Nuestros servicios</Link></li>
                          <li><Link to="/about" onClick={() => setDesktopMenuOpen(false)} className="block px-5 py-3 hover:bg-blue-900">Sobre nosotros</Link></li>
                          <li><Link to="/ubicacion" onClick={() => setDesktopMenuOpen(false)} className="block px-5 py-3 hover:bg-blue-900">Ubicación</Link></li>
                          <li><Link to="/contacto" onClick={() => setDesktopMenuOpen(false)} className="block px-5 py-3 hover:bg-blue-900">Contacto</Link></li>
                        </ul>
                      </div>
                    )}
                  </div>
                )}
              </div>
            <button
              onClick={handleNav}
              className="md:hidden p-2 rounded-lg hover:bg-[#06b6fa] transition"
              aria-label="Abrir menú"
            >
              <AiOutlineMenu
                className={`${inAdminView ? 'text-white' : 'text-white'}`}
                size={24}
              />
            </button>

            <div className="hidden md:flex items-center gap-3">
              {user?.rol === 'admin' && (
                <>

                  {inAdminView ? (
                    <button
                      onClick={goUsuario}
                      className="inline-flex items-center gap-2 text-sm px-3 py-2 rounded-md border border-white text-white hover:bg-blue-900"
                      title="Cambiar a vista usuario"
                    >
                      <FaExchangeAlt />
                      Vista usuario
                    </button>
                  ) : (
                    <button
                      onClick={goAdmin}
                      className="inline-flex items-center gap-2 text-sm px-3 py-2 rounded-md border border-white text-white hover:bg-blue-900"
                      title="Ir a vista admin"
                    >
                      <FaExchangeAlt />
                      Vista admin
                    </button>
                  )}
                </>
              )}

              {user?.rol === 'worker' && (
                <>
                  {inWorkerView ? (
                    <button
                      onClick={goUsuario}
                      className="inline-flex items-center gap-2 text-sm px-3 py-2 rounded-md border border-white text-white hover:bg-[#06b6fa]"
                      title="Cambiar a vista usuario"
                    >
                      <FaExchangeAlt />
                      Vista usuario
                    </button>
                  ) : (
                    <button
                      onClick={goTrabajador}
                      className="inline-flex items-center gap-2 text-sm px-3 py-2 rounded-md border border-white text-white hover:bg-[#06b6fa]"
                      title="Ir a vista trabajador"
                    >
                      <FaExchangeAlt />
                      Vista trabajador
                    </button>
                  )}
                </>
              )}

              {user ? (
                <div className="relative" ref={dropdownRef}>
                  <button
                    onClick={toggleDropdown}
                    className={`font-medium px-4 py-2 rounded transition inline-flex items-center gap-2 ${
                      inAdminView
                        ? 'bg-[#0b2052] border white text-white hover:bg-[#00698F]/15'
                        : 'bg-[#0b2052] border white text-white hover:bg-[#00698F]/15'
                    }`}
                    aria-expanded={dropdownOpen}
                  >
                    <span>{nombreUsuario}</span>
                    {user?.rol === 'admin' && (
                      <span
                        className={`ml-1 rounded-full px-2 py-0.5 text-xs font-semibold ${
                          inAdminView
                            ? 'bg-[#06b6fa]/20 text-white'
                            : 'bg-[#06b6fa]/20 text-white'
                        }`}
                      >
                        Admin
                      </span>
                    )}
                    {user?.rol === 'worker' && (
                      <span
                        className={`ml-1 rounded-full px-2 py-0.5 text-xs font-semibold ${
                          inAdminView
                            ? 'bg-white/20 text-white'
                            : 'bg-[#06b6fa]/20 text-white'
                        }`}
                      >
                        Worker
                      </span>
                    )}
                  </button>

                  {dropdownOpen && (
                    <ul className="absolute right-0 mt-2 w-64 bg-[#0b2052] border border-white rounded-lg shadow-lg text-sm z-50">
                      {user?.rol === 'admin' ? (
                        <li>
                          <button
                            onClick={handleLogout}
                            className="w-full text-left px-4 py-2 flex items-center gap-2 text-red-600 hover:bg-red-50"
                          >
                            <FaSignOutAlt />
                            Cerrar sesión
                          </button>
                        </li>
                      ) : user?.rol === 'worker' ? (
                        <>
                          <li>
                            <button
                              onClick={() => {
                                goTrabajador();
                                setDropdownOpen(false);
                              }}
                              className="w-full text-left px-4 py-2 hover:bg-blue-900 flex items-center gap-2"
                            >
                              <FaCalendarAlt className="text-white" />
                              Panel trabajador
                            </button>
                          </li>
                          <li>
                            <hr className="my-1 border-t" />
                          </li>
                          <li>
                            <button
                              onClick={handleLogout}
                              className="w-full text-left px-4 py-2 flex items-center gap-2 text-red-600 hover:bg-red-50"
                            >
                              <FaSignOutAlt />
                              Cerrar sesión
                            </button>
                          </li>
                        </>
                      ) : (
                        <>
                          <li>
                            <Link
                              to="/paciente/perfil"
                              className="flex items-center gap-2 px-4 py-2 hover:bg-blue-900"
                            >
                              <FaUser className="text-white" />
                              Perfil
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/paciente/sesiones"
                              className="flex items-center gap-2 px-4 py-2 hover:bg-blue-900"
                            >
                              <FaCalendarAlt className="text-white" />
                              Mis sesiones
                              {FEATURES.showSessionsBadge &&
                                upcomingCount > 0 && (
                                  <span className="ml-auto inline-flex items-center justify-center min-w-[22px] px-2 h-5 rounded-full bg-blue-100 text-blue-700 text-xs font-semibold">
                                    {upcomingCount}
                                  </span>
                                )}
                            </Link>
                          </li>
                          <li>
                            <hr className="my-1 border-t" />
                          </li>
                          <li>
                            <button
                              onClick={handleLogout}
                              className="w-full text-left px-4 py-2 flex items-center gap-2 text-red-600 hover:bg-red-50"
                            >
                              <FaSignOutAlt />
                              Cerrar sesión
                            </button>
                          </li>
                        </>
                      )}
                    </ul>
                  )}
                </div>
              ) : (
                <>
                  <Link
                    to="/login"
                    className={`font-semibold px-4 py-1 rounded-full transition ${
                      inAdminView
                        ? 'border border-white text-white hover:bg-[#06b6fa]'
                        : 'border border-white text-white hover:bg-[#06b6fa]'
                    }`}
                  >
                    Iniciar sesión
                  </Link>
                  <Link
                    to="/registro"
                    className={`${
                      inAdminView
                        ? 'text-white hover:underline'
                        : 'text-[#06b6fa] hover:underline'
                    } font-medium`}
                  >
                    Registrarse
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>

        {!inAdminView && !isWorkerRole && (
          <div className="hidden md:flex bg-[#06b6fa] py-3 items-center justify-center">
            <Link
              to="/agenda"
              className="
                bg-white
                text-[#00698F]
                px-8
                py-2.5
                rounded-full
                text-base
                font-semibold
                shadow-md
                hover:shadow-lg
                transition
              "
            >
              Agendar
            </Link>
          </div>
        )}

        {!inAdminView && !isWorkerRole && (
          <div className="bg-[#06b6fa] flex md:hidden justify-center items-center h-12">
            <Link
              to="/agenda"
              className="
                bg-white
                text-[#00698F]
                px-6
                py-2
                rounded-xl
                font-semibold
                shadow-md
                hover:shadow-lg
                transition
              "
            >
              Agendar
            </Link>
          </div>
        )}
      </div>

      {menuVisible && (
        <div
          className={`fixed inset-0 z-[999] transition-all duration-500 ease-in-out ${
            nav
              ? 'bg-black/30 backdrop-blur-sm'
              : 'bg-black/0 backdrop-blur-none'
          }`}
          onClick={handleNav}
        >
              <aside
                className={`fixed right-0 top-0 h-full w-[78%] max-w-xs
                ${inAdminView ? 'bg-[#0b2052] text-white' : 'bg-[#0b2052] text-white'}
                shadow-lg transform transition-transform duration-500 ease-in-out
                ${nav ? 'translate-x-0' : 'translate-x-full'}`}
                onClick={(e) => e.stopPropagation()}
              >
            <div className="flex items-center justify-between p-4 border-b">
              <img
                src={
                  inAdminView
                    ? '/fotos/Logo_blanco_EKINE.png'
                    : '/fotos/Logo_blanco_EKINE.png'
                }
                alt="EKINE"
                className={`h-8 w-auto ${
                  inAdminView ? 'bg-[#0b2052] rounded' : ''
                }`}
              />
              <button
                onClick={handleNav}
                aria-label="Cerrar menú"
                className="p-2 rounded hover:bg-[#06b6fa]"
              >
                <AiOutlineClose size={22} />
              </button>
            </div>

            <div className={`px-6 py-5 flex flex-col gap-4 font-semibold text-[16px] ${
                inAdminView ? 'text-white' : 'text-white'
              }`}>
              {inAdminView ? (
              <>
                <Link
                  to="/admin/agenda"
                  onClick={handleNav}
                  className="hover:text-[#06b6fa]"
                >
                  Agenda
                </Link>
                <Link
                  to="/admin/dashboard"
                  onClick={handleNav}
                  className="hover:text-[#06b6fa]"
                >
                  Dashboard
                </Link>
                <Link
                  to="/admin/pacientes"
                  onClick={handleNav}
                  className="hover:text-[#06b6fa]"
                >
                  Pacientes
                </Link>
                <Link
                  to="/admin/faq"
                  onClick={handleNav}
                  className="hover:text-[#06b6fa]"
                >
                  Preguntas frecuentes
                </Link>
                <Link
                  to="/admin/roles"
                  onClick={handleNav}
                  className="hover:text-[#06b6fa]"
                >
                  Gestión de roles
                </Link>
                <Link
                  to="/admin/cupones"
                  onClick={handleNav}
                  className="hover:text-[#06b6fa]"
                >
                  Cupones
                </Link>
                <Link
                  to="/admin/editarsitio"
                  onClick={handleNav}
                  className="hover:text-[#06b6fa]"
                >
                  Editar sitio
                </Link>
                <Link
                  to="/admin/desempeno-trabajadores"
                  onClick={handleNav}
                  className="hover:text-[#06b6fa]"
                >
                  Desempeño trabajadores
                </Link>

                <Link
                  to="/"
                  onClick={handleNav}
                  className="mt-3 px-4 py-3 bg-white text-[#0b2052] rounded-xl text-center font-bold shadow hover:bg-[#06b6fa] transition"
                >
                  Ir a vista usuario
                </Link>
              </>
            ) : inWorkerView ? (

                <>
                  <Link
                    to="/trabajador/agenda"
                    onClick={handleNav}
                    className="hover:text-[#06b6fa]"
                  >
                    Agenda
                  </Link>
                  <Link
                    to="/trabajador/pacientes"
                    onClick={handleNav}
                    className="hover:text-[#06b6fa]"
                  >
                    Pacientes
                  </Link>
                  <Link
                    to="/trabajador/seguimiento"
                    onClick={handleNav}
                    className="hover:text-[#06b6fa]"
                  >
                    Seguimiento de pacientes
                  </Link>
                  <Link
                    to="/trabajador/desempeno"
                    onClick={handleNav}
                    className="hover:text-[#06b6fa]"
                  >
                    Mi desempeño clínico
                  </Link>

                  <Link
                    to="/"
                    onClick={handleNav}
                    className="hover:text-[#06b6fa]"
                  >
                    Ir a vista usuario
                  </Link>
                </>
              ) : (
                <>
                  <Link
                    to="/"
                    onClick={handleNav}
                    className="hover:text-[#06b6fa]"
                  >
                    Inicio
                  </Link>
                  <Link
                    to="/servicios"
                    onClick={handleNav}
                    className="hover:text-[#06b6fa]"
                  >
                    Nuestros servicios
                  </Link>
                  <Link
                    to="/about"
                    onClick={handleNav}
                    className="hover:text-[#06b6fa]"
                  >
                    Sobre nosotros
                  </Link>
                  <Link
                    to="/ubicacion"
                    onClick={handleNav}
                    className="hover:text-[#06b6fa]"
                  >
                    Ubicación
                  </Link>
                  <Link
                    to="/contacto"
                    onClick={handleNav}
                    className="hover:text-[#06b6fa]"
                  >
                    Contacto
                  </Link>

                  {inWorkerView && (
                    <Link
                      to="/"
                      onClick={handleNav}
                      className="hover:text-[#06b6fa]"
                    >
                      Ir a vista usuario
                    </Link>
                  )}

                    {user?.rol === 'admin' && (
                      <Link
                        to="/agenda"
                        onClick={handleNav}
                        className="hover:text-[#06b6fa]"
                      >
                        Agendar
                      </Link>
                    )}
                </>
              )}

                {user?.rol === 'admin' && !inAdminView ? (
                  <>
                    <Link
                      to="/admin/agenda"
                      onClick={handleNav}
                      className="mt-4 w-full bg-white text-[#0b2052] text-center px-4 py-3 rounded-xl font-semibold shadow hover:bg-[#06b6fa] transition"
                    >
                      Ir a vista admin
                    </Link>
                  </>
                ) : (
                  !inAdminView && !isWorkerRole && (
                    <Link
                      to="/agenda"
                      onClick={handleNav}
                      className="mt-4 w-full bg-white text-[#0b2052] text-center px-4 py-3 rounded-xl font-semibold shadow hover:bg-[#06b6fa] transition"
                    >
                      Agendar ahora
                    </Link>
                  )
                )}

              {user ? (
                <div className="pt-4 border-t border-gray-100">
                  <button
                    onClick={toggleMobileUserMenu}
                    aria-expanded={mobileUserMenuOpen}
                    className="w-full px-3 py-3 rounded-xl border border-[#06b6fa] bg-[#0b2052]/10 hover:bg-[#0b2052]/15 transition flex items-center gap-3"
                  >
                    <div className="relative h-9 w-9 rounded-full bg-[#06b6fa] text-white grid place-items-center text-sm font-bold">
                      {getInitials(nombreUsuario)}
                    </div>
                    <div className="text-left flex-1 min-w-0">
                      <div className="text-white font-semibold truncate">
                        {nombreUsuario}
                      </div>
                      {user?.email && (
                        <div className="text-xs text-[#06b6fa] truncate">
                          {user.email}
                        </div>
                      )}
                    </div>
                    {user?.rol === 'admin' && (
                      <span className="mr-2 rounded-full bg-[#06b6fa]/15 text-white px-2 py-0.5 text-[10px] font-semibold">
                        Admin
                      </span>
                    )}
                    {user?.rol === 'worker' && (
                      <span className="mr-2 rounded-full bg-[#06b6fa]/15 text-white px-2 py-0.5 text-[10px] font-semibold">
                        Worker
                      </span>
                    )}
                    <FaChevronDown
                      className={`text-gray-500 transition-transform ${
                        mobileUserMenuOpen ? 'rotate-180' : ''
                      }`}
                    />
                  </button>

                  <div
                    className={`overflow-hidden transition-[max-height] duration-300 ease-in-out ${
                      mobileUserMenuOpen ? 'max-h-64' : 'max-h-0'
                    }`}
                  >
                    {user?.rol === 'admin' ? (
                      <button
                        onClick={() => {
                          if (window.confirm('¿Cerrar sesión?')) {
                            handleLogout();
                            handleNav();
                          }
                        }}
                        className="mt-2 w-full text-red-600 border border-red-200 hover:bg-red-50 rounded-xl px-4 py-3 flex items-center justify-center gap-2 font-semibold bg-white"
                      >
                        <FaSignOutAlt />
                        Cerrar sesión
                      </button>
                    ) : user?.rol === 'worker' ? (
                      <>
                        <button
                          onClick={() => {
                            goTrabajador();
                            handleNav();
                          }}
                          className="mt-2 w-full border border-[#06b6fa] text-[#0b2052] hover:bg-blue-200 rounded-xl px-4 py-3 flex items-center justify-center gap-2 font-semibold bg-white"
                        >
                          <FaCalendarAlt className="text-[#0b2052]" />
                          Panel trabajador
                        </button>
                        <button
                          onClick={() => {
                            if (window.confirm('¿Cerrar sesión?')) {
                              handleLogout();
                              handleNav();
                            }
                          }}
                          className="mt-2 w-full text-red-600 border border-red-200 hover:bg-red-50 rounded-xl px-4 py-3 flex items-center justify-center gap-2 font-semibold"
                        >
                          <FaSignOutAlt />
                          Cerrar sesión
                        </button>
                      </>
                    ) : (
                      <>
                        <ul className="mt-2 rounded-xl border border-gray-200 bg-[#0b2052] divide-y">
                          <li>
                            <Link
                              to="/paciente/perfil"
                              onClick={handleNav}
                              className="flex items-center gap-3 px-4 py-3 hover:bg-[#06b6fa]"
                            >
                              <FaUser className="text-white" />
                              <span className="text-[15px]">Perfil</span>
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/paciente/sesiones"
                              onClick={handleNav}
                              className="flex items-center gap-3 px-4 py-3 hover:bg-[#06b6fa]"
                            >
                              <FaCalendarAlt className="text-white" />
                              <span className="text-[15px]">Mis sesiones</span>
                              {FEATURES.showSessionsBadge &&
                                upcomingCount > 0 && (
                                  <span className="ml-auto inline-flex items-center justify-center min-w-[22px] px-2 h-5 rounded-full bg-blue-100 text-blue-700 text-xs font-semibold">
                                    {upcomingCount}
                                  </span>
                                )}
                            </Link>
                          </li>
                          <li></li>
                        </ul>
                        <button
                          onClick={() => {
                            if (window.confirm('¿Cerrar sesión?')) {
                              handleLogout();
                              handleNav();
                            }
                          }}
                          className="mt-2 w-full text-red-600 border border-red-200 hover:bg-red-50 rounded-xl px-4 py-3 flex items-center justify-center gap-2 font-semibold"
                        >
                          <FaSignOutAlt />
                          Cerrar sesión
                        </button>
                      </>
                    )}
                  </div>
                </div>
              ) : (
                <div className="pt-4 border-t border-gray-100 flex gap-3">
                  <Link
                    to="/login"
                    onClick={handleNav}
                    className="flex-1 text-center border border-white text-white px-4 py-2 rounded-lg hover:bg-[#06b6fa]"
                  >
                    Iniciar sesión
                  </Link>
                  <Link
                    to="/registro"
                    onClick={handleNav}
                    className="flex-1 text-center border border-[#06b6fa] bg-white text-[#0b2052] px-4 py-2 rounded-lg hover:bg-[#06b6fa]"
                  >
                    Registrarse
                  </Link>
                </div>
              )}

              <div className="px-6 pt-3 pb-4 border-t">
                <div className="flex items-center justify-center gap-4">
                  <a
                    href={config.instagram}
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Instagram"
                    className={`p-2 rounded-md transition
                      ${inAdminView ? 'text-white hover:bg-white/10' : 'text-white hover:bg-white/10'}
                    `}
                  >
                    <FaInstagram size={24} />
                  </a>
                  <a
                    href={`https://wa.me/${config.whatsapp.replace("+","")}`}
                    target="_blank"
                    rel="noreferrer"
                    aria-label="WhatsApp"
                    className={`p-2 rounded-md transition
                      ${inAdminView ? 'text-white hover:bg-white/10' : 'text-white hover:bg-white/10'}
                    `}
                  >
                    <FaWhatsapp size={24} />
                  </a>
                </div>
                <p className="mt-3 text-[11px] text-gray-300 leading-snug text-center">
                  <a
                    href={config.googleMaps}
                    target="_blank"
                    rel="noreferrer"
                    className="hover:underline text-[white]"
                  >
                    {config.horario_texto + " — " + config.ubicacion_texto}
                  </a>
                </p>
                <p className="mt-1 text-[11px] text-[#06b6fa] text-center">
                  © 2025 EKINE
                </p>
              </div>
            </div>
          </aside>
        </div>
      )}

    </>
  );
};

export default Navbar;
